import * as Yup from "yup";



export const initialValues = {
  fullName: null,
  relationship: null,
  dateOfBirth: null,
  career: null,
  mobileNumber: null,

};

const EmployeeInfoFamilySchema = Yup.object().shape({
  fullName: Yup.string().required("Please enter name."),
  relationship: Yup.string().required("Please select relationship"),
  // dateOfBirth: Yup.string().required("Please select date of birth."),
  // genderId: Yup.string().required("Please select gender"),
  // employeeNationality: Yup.string().required("Please select nationality."),
  // // raceId: Yup.string().required("Please select race."),
  // // nationalityId: Yup.string().required("Please select nationality."),
  // religionId: Yup.string().required("Please select religion."),
  // maritalStatusId: Yup.string().required("Please select marital status."),
  // militaryStatusId: Yup.string().required("Please select military status."),
  // bloodGroupId: Yup.string().required("Please blood group."),
  // weight: Yup.string().required("Please enter weight."),
  // height: Yup.string().required("Please enter height."),
});

export default EmployeeInfoFamilySchema;
